import script from "./ListaTrilhaDeAcolhimento.vue?vue&type=script&setup=true&lang=js"
export * from "./ListaTrilhaDeAcolhimento.vue?vue&type=script&setup=true&lang=js"

import "./ListaTrilhaDeAcolhimento.vue?vue&type=style&index=0&id=0fda40e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fda40e0"]])

export default __exports__